module.exports = __webpack_public_path__ + "img/实名提示.64294d36.png";